<template>
    <div class="accountSetBox">
        <div class="titleDiv">
            <span class="lf titleColor"></span>
            <p class="lf titleP">账户设置</p>
        </div>
        <div class="content">
            <Tabs value="name1" :animated="false">
                <TabPane label="密码修改" name="name1">
                    <update-pwd></update-pwd>
                </TabPane>
                <TabPane label="基本信息修改" name="name2">
                    <basic-msg :userInfoData="userInfoData"></basic-msg>
                </TabPane>
               <!-- <TabPane label="常用代理人修改" name="name3">
                    <common-agent :userAgentData="userAgentData"></common-agent>
                </TabPane>
                <TabPane label="常用邮递修改" name="name4">
                    <common-mail :userInfoData="userInfoData"></common-mail>
                </TabPane>
                <TabPane label="常用材料" name="name5">
                    <common-materials></common-materials>
                </TabPane>-->
            </Tabs>
        </div>
    </div>
</template>

<script>
    import updatePwd from './updatePwd';
    import basicMsg from './basicMsg';
    // import commonAgent from './commonAgent';
    // import commonMail from './commonMail';
    // import commonMaterials from './commonMaterials';
    import {getUsCode} from "../../../utils/auth";
    import {userInfo, agentInfo} from '@/api/manager_user'

    export default {
        name: "accountSet",
        components: {
            updatePwd,
            basicMsg,
            // commonAgent,
            // commonMail,
            // commonMaterials
        },
        data() {
            return {
                userInfoData: '',
                userAgentData: ''
            }
        },
        methods: {
            // 加载用户信息
            getUserInfo() {
                return new Promise((resolve, reject) => {
                    let params = {
                        userLoginName: getUsCode(),
                        _dc: new Date().getTime()
                    };
                    userInfo(params).then(response => {
                        const resData = response.data;
                        if (resData.status !== 0) {
                            this.$Message.error(resData.msg);
                        } else {
                            this.userInfoData = resData.data;
                        }
                        resolve();
                    }).catch(error => {
                        reject(error);
                    });
                })
            },
            // 加载用户代理信息
            getUserAgent() {
                return new Promise((resolve, reject) => {
                    let params = {
                        userLoginName: getUsCode(),
                        _dc: new Date().getTime()
                    };
                    agentInfo(params).then(response => {
                        const resData = response.data;
                        if (resData.status === 0) {
                            this.userAgentData = resData.data;
                        }
                        resolve();
                    }).catch(error => {
                        reject(error);
                    });
                })
            }
        },
        mounted() {
            this.getUserInfo();
            this.getUserAgent();
        }
    }
</script>

<style lang="less" scoped>
    @import url("../../../../static/css/common.less");

    .accountSetBox {
        width: 100%;
        height: 100%;
        padding: 17px 5px 0 5px;
        box-sizing: border-box;

        .titleDiv {
            width: 100%;
            height: 30px;
            margin-bottom: 32px;

            .titleColor {
                width: 4px;
                height: 24px;
                background: #4AA4FF;
                margin: 3px 18px 0 0;
            }

            .titleP {
                font-size: 22px;
                color: @contentTitleColor;
                height: 30px;
                line-height: 30px;
            }
        }

        .content {
            /deep/ .ivu-tabs-ink-bar {
                display: none;
            }

            /deep/ .ivu-tabs-bar {
                border: none;
            }

            /deep/ .ivu-tabs-nav {
                text-align: center;
                float: unset;
            }

            /deep/ .ivu-tabs-nav .ivu-tabs-tab {
                margin: 0 20px;
                color: #C0C4CC;
                font-size: 18px;

                &::before {
                    content: "";
                    width: 6px;
                    height: 6px;
                    background: #C0C4CC;
                    border-radius: 50%;
                    position: absolute;
                    top: 50%;
                    margin-top: -3px;
                    left: 0;
                }

                &.ivu-tabs-tab-active {
                    color: #4AA4FF;

                    &::before {
                        background: #4AA4FF;
                    }
                }
            }
        }
    }
</style>
